import styled from 'styled-components';

export default {
  TestP: styled.p`
    color: red;
    font-size: 45px;
    line-height: 60px;
  `
}